import globalAxios from 'axios';
import { ENV } from '../../environment.js';
import { SamplesApi } from './generated/api.js';
import { Configuration } from './generated/configuration.js';

const RECO_EXTERNAL_API_URL = ENV.REACT_APP_RECO_EXTERNAL_API_URL;
const samplesAPI = new SamplesApi(new Configuration({
    basePath: RECO_EXTERNAL_API_URL,
}), undefined, globalAxios);

export { samplesAPI };
//# sourceMappingURL=api.js.map
